import type { CloudpackConfig, PackageSettingsMatch } from '@ms-cloudpack/common-types';
import type { LoginMethod } from '@ms-cloudpack/remote-cache';

/**
 * Types for options from `reusedOptions.ts` (pick the properties you need).
 */
export interface ReusedOptions extends Pick<CloudpackConfig, 'logBundleInfo' | 'mode'> {
  /** Specifies which app to operate on, in the command is run at a higher level in the repo. */
  app?: string;

  /**
   * Force using a specific bundler (ori/rollup/rspack/webpack).
   *
   * Default is automatically choosing the bundler based on package contents, unless there any
   * relevant package settings specify a bundler.
   */
  // As of writing this is just used in BundleOptions, but having it here helps with typing of the
  // config option logic in CommandExecutor.
  bundler?: string;

  /** Whether to use the cache */
  cache?: boolean;

  /** Writes the resolve map to `resolve-map.json`. */
  logResolveMap?: boolean;

  /** Only evaluate/consider specific package(s). */
  match?: PackageSettingsMatch[];

  /** How to authenticate against the remote cache */
  login: LoginMethod;
}
